import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { NotifyService } from '@src/app/shared/services/notiflix/notify.service';
import { iApiResponse } from '@src/app/core/interfaces/iApiResponse';

@Injectable({
  providedIn: 'root'
})
export class AuthPermissionApi {

  private http = inject(HttpClient);
  private readonly baseUrl = environment.urlApi + '/v2/auth';

  getAll(): Observable<iApiResponse> {
    return this.http.get<iApiResponse>(`${this.baseUrl}/permissions`);
  }


}
